import { Injectable } from '@angular/core';
import { environment } from '@app/../environments/environment';
import * as Sentry from '@sentry/angular-ivy';

@Injectable({
  providedIn: 'root'
})
export class SentryService {

  constructor() {
    if (environment.sentry.enabled && environment.sentry.dsn) {
      this.initSentry();
    }
  }

  private initSentry(): void {
    Sentry.init({
      dsn: environment.sentry.dsn,
      environment: environment.sentry.environment,
      tracesSampleRate: environment.sentry.tracesSampleRate,
      release: environment.name + '@' + (environment.production ? 'prod' : 'dev'),
      beforeSend(event, hint) {
        // Filter out any sensitive data here
        if (event.exception) {
          const error = hint.originalException;
          console.error('Sentry Error:', error);
        }
        return event;
      }
    });
  }

  /**
   * Manually capture an exception
   */
  captureException(error: any): void {
    if (environment.sentry.enabled) {
      Sentry.captureException(error);
    }
  }

  /**
   * Manually capture a message
   */
  captureMessage(message: string, level: Sentry.SeverityLevel = 'error'): void {
    if (environment.sentry.enabled) {
      Sentry.captureMessage(message, level);
    }
  }
}
